import { Box, List, ListItem, Typography } from '@mui/material';
import { RentalLocationType } from '~/data/types/rentalLocationsType';
import Location from './Location/Location';
import classes, { listItem, TitleStyle } from './styles';
import { useIsMobile } from '~/hooks/useIsMobile';
import { useEffect, useRef, useState } from 'react';

interface RentalBranchesProps {
  title: string;
  branches: Record<string, RentalLocationType[]>;
  onClickLocation: (location: RentalLocationType) => void;
}

const CitiesInput = ({
  title,
  branches,
  onClickLocation,
}: RentalBranchesProps) => {
  const isMobile = useIsMobile();

  const menuRefs = useRef<(HTMLLIElement | null)[]>([]);
  const [focusedIndex, setFocusedIndex] = useState<number>(0);
  const locationsList = Object.entries(branches).flatMap(
    ([_, locations]) => locations,
  );

  const handleKeyDown = (event: React.KeyboardEvent, index: number) => {
    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        setFocusedIndex((prev) =>
          prev === null || prev === locationsList.length - 1 ? 0 : prev + 1,
        );
        break;
      case 'ArrowUp':
        event.preventDefault();
        setFocusedIndex((prev) =>
          prev === null || prev === 0 ? locationsList.length - 1 : prev - 1,
        );
        break;
      case 'Enter':
      case ' ':
        event.preventDefault();
        onClickLocation(locationsList[index]);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    if (menuRefs.current[focusedIndex]) {
      menuRefs.current[focusedIndex]?.focus();
    }
  }, [focusedIndex]);

  useEffect(() => {
    if (menuRefs.current[0]) {
      setFocusedIndex(0);
      menuRefs.current[0]?.focus();
    }
  }, []);

  let globalIndex = 0;

  return (
    <Box sx={classes.root}>
      {isMobile && (
        <Box sx={{ ...classes.Title, ...classes.mainTitle }}>
          <Typography sx={TitleStyle}>{title}</Typography>
        </Box>
      )}
      <List sx={classes.branchesOptionsContainer}>
        {Object.entries(branches).map(([region, locations]) => (
          <Box key={region} sx={classes.regionLocationContainer}>
            <Box sx={classes.Title}>
              <Typography sx={TitleStyle}>{region}</Typography>
            </Box>
            <Box sx={classes.locationContainer}>
              {locations.map((location, index) => (
                <ListItem
                  key={location.id}
                  tabIndex={0}
                  role="button"
                  onKeyDown={(event) => handleKeyDown(event, index)}
                  onClick={() => onClickLocation(location)}
                  sx={listItem}
                  ref={(el) => {
                    menuRefs.current[globalIndex++] = el;
                  }}
                >
                  <Location
                    onClickLocation={onClickLocation}
                    location={location}
                    region={region}
                  />
                </ListItem>
              ))}
            </Box>
          </Box>
        ))}
      </List>
    </Box>
  );
};

export default CitiesInput;
